import * as tertiary from "../../../../fonts/tertiary"

const TertiaryFonts = `
@font-face {
  font-family: 'Liu Jian Mao Cao';
  font-style: normal;
  font-weight: 400;
  src: local('Liu Jian Mao Cao Regular'), local('LiuJianMaoCao-Regular'),
       url('${tertiary.WOFF2_4}') format('woff2'),
       url('${tertiary.WOFF_4}') format('woff');
}

`

export default TertiaryFonts
